import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import { PaymentMethod } from "../../../../../../models/PaymentMethod";
import { defer } from "../../../../../../utils/script";
import CardItem from "../CardItem";
import FundiinPayment from "../FundiinPayment";
import DIframe from "../../../../../../components/DIframe";

export default class PaymentList extends DComponent {
  constructor({
    parent,
    id,
    paymentList = [],
    paymentMethodCode,
    paymentMethod,
    paymentProvider,
    onSelectPayment = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("PaymentList", {

      }),

    }, true);
    this.paymentMethodCode = paymentMethodCode;
    this.paymentMethod = paymentMethod;
    this.paymentProvider = paymentProvider;
    this.onSelectPayment = onSelectPayment;
    /**@type {[PaymentMethod]} */
    this.paymentList = paymentList;
    /**@type {[CardItem]} */
    this.paymentListItem = [];
    this.fundiinModal = undefined;
    this.iframe = new DIframe({ parent: '.main-page', isDialog: true });
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "PaymentList");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.fillData();
  }

  fillData(isRefresh = false) {
    if (isRefresh) {
      this.paymentListItem = [];
      this.element.html("");
    }
    if (this.paymentList.length) {
      this.paymentList.forEach(element => {
        this.paymentListItem.push(new CardItem({
          option: PaymentMethod.OPTION.OTHER,
          type: CardItem.CARD_TYPE.PARENT,
          parent: this.element,
          paymentMethodCode: element.paymentMethodCode,
          paymentMethod: element.paymentMethod,
          paymentProvider: element.paymentProvider,
          isChoose: true,
          onClick: (e) => this.onSelect(e),
          onNotice: (e) => this.onNotice(e),
          isActive: (this.paymentMethodCode && this.paymentMethodCode === element.paymentMethodCode) ||
            (!this.paymentMethodCode && this.paymentMethod === element.paymentMethod && this.paymentProvider === element.paymentProvider)
        }))
        if (PaymentMethod.isFundiin(element.paymentMethod, element.paymentProvider) && !this.fundiinModal) {
          this.fundiinModal = new FundiinPayment({ parent: ".main-page" })
        }
      });
    }
  }

  /** @param {CardItem} cardItem */
  onSelect(cardItem) {
    if ((cardItem.paymentMethodCode && cardItem.paymentMethodCode === this.paymentMethodCode) ||
      (cardItem.paymentMethod === this.paymentMethod && cardItem.paymentProvider === this.paymentProvider)
    ) {
      this.isShorten(!this.element.hasClass("shorten"));
      return;
    }

    if (cardItem.option === PaymentMethod.OPTION.OTHER) {
      this.paymentListItem.forEach(element => { element.setActive(element.id === cardItem.id); });
    }
    this.paymentMethodCode = cardItem.paymentMethodCode;
    this.paymentMethod = cardItem.paymentMethod;
    this.paymentProvider = cardItem.paymentProvider;

    typeof this.onSelectPayment === "function" && this.onSelectPayment({
      paymentMethodCode: cardItem.paymentMethodCode,
      paymentMethod: cardItem.paymentMethod,
      paymentProvider: cardItem.paymentProvider
    });

    this.element.addClass("has-selected");
  }

  /** @param {CardItem} cardItem */
  onNotice(cardItem) {
    if (PaymentMethod.isFundiin(cardItem.paymentMethod, cardItem.paymentProvider)) {
      this.fundiinModal.show();
    }
    if (PaymentMethod.isPromotion(cardItem.paymentMethod, cardItem.paymentProvider)) {

    }
  }

  /** @param {PaymentList} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
      this.fillData(true)
    });
  }

  /** @param {[PaymentMethod]} paymentList */
  validatePaymentList() {
    let isValid = true;
    if (this.paymentMethodCode) {
      return isValid;
    }
    let payment = this.paymentList.find(item => item.paymentMethod === this.paymentMethod && (!this.paymentProvider || item.paymentProvider === this.paymentProvider));
    if (!payment) {
      isValid = false;
    }

    return isValid;
  }

  resetPaymentList() {
    this.paymentMethodCode = "";
    this.paymentMethod = "";
    this.paymentProvider = "";
    this.paymentListItem.forEach(element => { element.setActive(false); });
    this.element.removeClass("has-selected");
  }

  /** @returns {PaymentMethod} */
  getCurrentPayment() {
    return new PaymentMethod(this.paymentMethodCode, this.paymentProvider, this.paymentMethod)
  }

  isShorten(isShorten) {
    isShorten ? this.element.addClass("shorten") : this.element.removeClass("shorten");
  }

  showPaymentItem(paymentMethod, paymentProvider, isShow) {
    $(`.CardItem.m-${paymentMethod}.p-${paymentProvider}`, this.element).toggleClass("hide", !isShow);
  }
}